import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-duplicate-name',
  templateUrl: './duplicate-name.component.html',
  styleUrls: ['./duplicate-name.component.scss']
})
export class DuplicateNameComponent {
  @Input() public duplicateNames: string[];

  @Output() public decideForEachDrawing: EventEmitter<void> = new EventEmitter<void>();
  @Output() public skipDuplicates: EventEmitter<void> = new EventEmitter<void>();
  @Output() public overwriteDuplicates: EventEmitter<void> = new EventEmitter<void>();

  public decideForEachDrawingClicked(): void {
    this.decideForEachDrawing.emit();
  }

  public skipDuplicatesClicked(): void {
    this.skipDuplicates.emit();
  }

  public overwriteDuplicatesClicked(): void {
    this.overwriteDuplicates.emit();
  }
}
